import React from "react"
import { MdDelete, MdModeEditOutline } from "react-icons/md"
import { useMediaQuery } from "react-responsive"
import { FixedSizeList } from "react-window"
import { CheckBox } from "../Form"

import "./styles.scss"
import ModalAlert from "../ModalAlert"

const TagList = ({
  data,
  onEditTag,
  onRemoveTag,
  handleSelectedTag,
  selectedTag,
  handleSelectedTagAll
}) => {
  const Row = ({ index, style }) => {
    const row = data[index]
    return (
      <>
        {row && (
          <div style={style}>
            <li className="tag-content__list-group-item" style={{ borderLeftColor: row.text_color }}>
              <div class="tag-item">
                <CheckBox
                  onChange={handleSelectedTag}
                  value={row.id}
                  checked={selectedTag?.some((val) => val === row.id)}
                />
                <div className="tag-item__group">
                  <span
                    class=""
                    role="presentation"
                    title={row.name}>
                    {row.name}
                  </span>
                  {(row.project || row.projectId) && (
                    <div class="tag-item__group-buttons">
                      <button onClick={() => onEditTag(row)}>
                        <MdModeEditOutline size={20} color="#FF4001" />
                      </button>
                      <button
                        onClick={() =>
                          ModalAlert.danger({
                            title: "Deseja Remover esta tag?",
                            confirmLabel: "Sim",
                            onConfirm: () => {
                              onRemoveTag(row.id)
                            },
                          })
                        }>
                        <MdDelete size={20} color="#c80e00" />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </li>
          </div>
        )}
      </>
    )
  }

  const M = useMediaQuery({ query: "(max-height:768px)" })

  return (
    <div className="tag-content">
      {data.length > 0 && (
        <>
        <div style={{display: "flex", gap: "16px"}}>
        <CheckBox
        label="Todas"
        onChange={handleSelectedTagAll}
        checked={selectedTag?.length === data?.length}
      />
        </div>
        <FixedSizeList
          height={M ? 260 : 330}
          itemCount={data.length}
          itemSize={45}
          width={"100%"}
          innerElementType="ul"
          itemData={data}
          className="scroll-tag-list">
          {Row}
        </FixedSizeList>
        </>
      )}
    </div>
  )
}

export default TagList
